import { get, post } from "helpers/api_helper"
import { toast } from "react-toastify"

export async function getPublications({
  page = 1,
  size,
  setTableData,
  setCurrentPage,
  setTotalPages,
  setLoading,
  setTotalItems,
  setFilteredIds,
  startDate,
  endDate,
  text,
}) {
  const url =
    `${process.env.REACT_APP_API_INT_LEADS}/api/resultados-publicacao-final/filter`
  const payload = { page, pageSize: size, startDate, endDate, text }

  try {
    const response = await post(url, payload)

    setTableData(response.data)
    setCurrentPage(response.currentPage)
    setTotalPages(response.totalPages)
    setTotalItems(response.totalItems)
    setFilteredIds(response?.ids || [])
  } catch (error) {
    toast.error(error.response.data.message)
  } finally {
    setLoading(false)
  }
}

export async function postAnalise({ rowsSelected, analise }) {
  const url =
    `${process.env.REACT_APP_API_INT_LEADS}/api/resultados-publicacao-final/analisar`
    const payload = { items: rowsSelected, analisar: analise }

  try {
    const response = await post(url, payload)

    return response.message
  } catch (error) {
    console.error("Erro ao analisar", error)
  }
}

export async function getTags(setTags) {
  const url = `${process.env.REACT_APP_API_INT_LEADS}/api/tags`

  try {
    const response = await get(url)

    const uniqueTags = Array.from(
      new Map(response.map(tag => [tag.Titulo, tag])).values()
    )

    const tagsData = uniqueTags.map(tag => ({
      id: tag.Id,
      title: tag.Titulo,
    }))

    setTags(tagsData)
  } catch (error) {
    console.error("Erro ao buscar tags", error)
  }
}
